import Dashboard from "../EmployeeDashboard/Dashboard";

const LeadsDashboard = () => {
    return (
        <div>
            <Dashboard isLeadDashboard={true}/>
        </div>
    )
}

export default LeadsDashboard;